import { ERROR_STATUS_CODES, ERROR_TAGS } from '@/modules/error/domain/error.constants';
import { getLoggerService } from '@/modules/logger/infrastructure/loggerService';
import { COOKIES } from '@/services/constants';
import { Helpers } from '@/services/helpers';

export default function ({ route, redirect, $cookies, $api, $payment, $login, ssrContext }) {
  const { logger } = getLoggerService();

  const correlationId = process.server ? ssrContext?.req?.correlationId : undefined;

  const addCorrelationId = (config) => {
    if (correlationId) {
      config.headers['x-correlation-id'] = correlationId;
    }
    return config;
  };

  $api.interceptors.request.use(function (config) {
    addCorrelationId(config);
    const token = $cookies.get(COOKIES.token);

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  });

  $payment.interceptors.request.use(addCorrelationId);
  $login.interceptors.request.use(addCorrelationId);

  $api.onRequest((config) => {
    logger.info('Making request', { url: config.url, client: 'api' });
  });

  $payment.onRequest((config) => {
    logger.info('Making request', { url: config.url, client: 'payment' });
  });

  $login.onRequest((config) => {
    logger.info('Making request', { url: config.url, client: 'login' });
  });

  $api.onError((error) => {
    const statusCode = error?.response?.status;

    if (statusCode === ERROR_STATUS_CODES.UNAUTHORIZED) {
      return redirect(Helpers.getLoginUrl({ redirectPath: route.path }));
    }

    if (error.code === 'ECONNABORTED' || !error.response) {
      const networkError = new Error('Network error occurred');
      networkError.code = error.code;
      networkError.config = error.config;
      throw networkError;
    }

    return Promise.reject(error);
  });

  $payment.onError((error) => {
    logger.error(`Payment API Error: ${error.message}`, {
      tags: [ERROR_TAGS.API_ERROR],
      statusCode: error?.response?.status,
      url: error.config?.url,
      method: error.config?.method,
      errorMessage: error.message,
      responseData: error.response?.data,
    });
  });

  $login.onError((error) => {
    logger.error(`Login API Error: ${error.message}`, {
      tags: [ERROR_TAGS.API_ERROR],
      statusCode: error?.response?.status,
      url: error.config?.url,
      method: error.config?.method,
      errorMessage: error.message,
      responseData: error.response?.data,
    });
  });
}
